"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImplementationRulesRequirement = void 0;
exports.implementationRuleAssertionSlug = implementationRuleAssertionSlug;
const IMPLEMENTATION_RULES_REQUIREMENT_ID = 'req_cadstromimr0000000000000000000000000';
exports.ImplementationRulesRequirement = {
    id: IMPLEMENTATION_RULES_REQUIREMENT_ID,
    slug: 'cadstrom.implementation_rules',
    slugPrefix: 'IMR',
    name: 'Implementation Rules',
    description: 'Checks each build module against the implementation rules of the package it resolves to. Each rule is its own assertion definition, minted per package.',
    assertionsEnumerable: false,
};
function implementationRuleAssertionSlug(packageId, ruleId) {
    return `${exports.ImplementationRulesRequirement.slug}.${packageId}.${ruleId}`;
}
//# sourceMappingURL=implementation-rules.js.map